import React, { createContext, useContext, useState } from 'react';
import { useTradeConfirmationService } from '../services/tradeConfirmationService';
import { AuthContext } from './AuthContext';

const TradeConfirmationContext = createContext();

export const useTradeConfirmationContext = () => {
  const context = useContext(TradeConfirmationContext);
  if (!context) {
    throw new Error('useTradeConfirmationContext must be used within a TradeConfirmationProvider');
  }
  return context;
};

export const TradeConfirmationProvider = ({ children }) => {
  const { user, updateUserSettings } = useContext(AuthContext);
  const { updateTradeConfirmation } = useTradeConfirmationService();
  const [isLoading, setIsLoading] = useState(false);

  // Get trade confirmation setting from user object in AuthContext
  const tradeConfirmation = user?.tradeConfirmation !== false;

  const updateTradeConfirmationSetting = async (enabled) => {
    setIsLoading(true);
    try {
      const updatedSettings = await updateTradeConfirmation(enabled, user);
      // Update the AuthContext with the new settings from the backend response
      updateUserSettings(updatedSettings);
      return updatedSettings;
    } catch (error) {
      console.error('Error updating trade confirmation setting:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const value = {
    tradeConfirmation,
    isLoading,
    updateTradeConfirmationSetting
  };

  return (
    <TradeConfirmationContext.Provider value={value}>
      {children}
    </TradeConfirmationContext.Provider>
  );
}; 